import Cookies from 'universal-cookie';
import { getIdentityEnv, getIdentityRedirectUri, identityLoginUrl } from './methods';
//@ts-ignore
import AceIdentity from '@ace-clublabs/ace-identity';
import { TOKEN_KEY_MAX_AGE, TOKEN_KEY_PAYMENTS } from '../constants';

const cookies = new Cookies();

export const getAccessToken = async () => {
  const env = getIdentityEnv();
  const aceIdentity = new AceIdentity({
    env,
    redirectUri: getIdentityRedirectUri(),
    loginUrl: identityLoginUrl(),
    bypassAuth2: env === 'non-prod' ? true : false,
    disableBypassPkce: false,
  });
  await aceIdentity.ready();
  const { accessToken } = await aceIdentity.tokens();
  await cookies.set(TOKEN_KEY_PAYMENTS, accessToken, { path: '/', maxAge: TOKEN_KEY_MAX_AGE });
};
